var DALGAKIRAN = {
    controls: {
        mobile: matchMedia('(min-width: 950px)')
    },
    browser: (function () {

        var os = '',
            version,
            ua = window.navigator.userAgent,
            platform = window.navigator.platform,
            result = {
                os: {
                    win: false,
                    mac: false,
                    linux: false,
                    android: false,
                    ios: false
                },
                browser: {
                    opera: false,
                    ie: false,
                    firefox: false,
                    chrome: false,
                    safari: false,
                    android: false
                },
                version: 0
            };

        if (/MSIE/.test(ua)) {
            version = /MSIE \d+[.]\d+/.exec(ua)[0].split(' ')[1];
            result.browser.ie = true;
            result.version = parseInt(version, 10);
        } else if (/Android/.test(ua)) {
            result.os.android = true;
            result.browser.android = true;

            if (/Chrome/.test(ua)) {
                version = /Chrome\/[\d\.]+/.exec(ua)[0].split('/')[1];
                result.version = parseInt(version, 10);
                result.browser.chrome = true;

                result.browser.android = false;
            }

            if (/Firefox/.test(ua)) {
                version = /Firefox\/[\.\d]+/.exec(ua)[0].split('/')[1];
                result.browser.firefox = true;
                result.version = parseInt(version, 10);

                result.browser.android = false;
            }

        } else if (/Chrome/.test(ua)) {
            version = /Chrome\/[\d\.]+/.exec(ua)[0].split('/')[1];
            result.browser.chrome = true;
            result.version = parseInt(version, 10);
        } else if (/Opera/.test(ua)) {
            result.browser.opera = true;
        } else if (/Firefox/.test(ua)) {
            version = /Firefox\/[\.\d]+/.exec(ua)[0].split('/')[1];
            result.browser.firefox = true;
            result.version = parseInt(version, 10);
        } else if (/Safari/.test(ua)) {

            if ((/iPhone/.test(ua)) || (/iPad/.test(ua)) || (/iPod/.test(ua))) {
                result.os.ios = true;
            }

            result.browser.safari = true;
        }

        if (!version) {

            version = /Version\/[\.\d]+/.exec(ua);

            if (version) {

                if (version) {
                    version = version[0].split('/')[1];
                } else {
                    version = /Opera\/[\.\d]+/.exec(ua)[0].split('/')[1];
                }

                result.version = parseInt(version, 10);
            } else {

                if (document.all.length) {
                    result.version = 11;
                    result.browser.ie = true;
                }

            }
        }

        if (platform === 'MacIntel' || platform === 'MacPPC') {
            result.os.mac = true;
        } else if (platform === 'Win32' || platform === 'Win64') {
            result.os.win = true;
        } else if (!os && /Linux/.test(platform)) {
            result.os.linux = true;
        } else if (!os && /Windows/.test(ua)) {
            result.os.win = true;
        } else if (!os && /android/.test(ua)) {
            result.os.android = true;
        }

        return result;

    }()),
    global: {
        touchScrollStart: function (event) {
            event.stopPropagation();
            this.allowUp = (this.scrollTop > 0);
            this.allowDown = (this.scrollTop < this.scrollHeight - this.clientHeight);
            this.lastY = event.touches[0].clientY;
        },

        touchScrollProcessing: function (event) {
            var up = (event.touches[0].clientY > this.lastY),
                down = !up;

            this.lastY = event.touches[0].clientY;

            if ((up && this.allowUp) || (down && this.allowDown)) {
                event.stopPropagation();
            } else {
                if (this.scrollHeight !== this.clientHeight || this.scrollHeight + 1 !== this.clientHeight) {
                    event.preventDefault();
                }
            }
        },

        formSubmit: function (event) {
            var form = event.target,
                formData;

            if (!module.validation.check(form)) {
                event.preventDefault();
                return;
            }

            if (!form.hasAttribute('data-ajax')) {
                return;
            }

            event.preventDefault();

            formData = new FormData(form);

            fetch(form.getAttribute('action'), {
                method: form.getAttribute('method'),
                body: formData
            }).then(function (response) {
                module.listener.exec(form.getAttribute('id'), response);
            }).catch(function (error) {
                console.log('submit form error', error);
            });
        },

        cover: function (object, viewPortWidth, viewPortHeight) {
            "use strict";

            var viewPortRatio = viewPortWidth / viewPortHeight,
                imageRatio,
                resultWidth,
                resultHeight,
                hiddenTop = 0,
                hiddenLeft = 0;

            object.style.display = 'none'; // need for correct rendering in firefox (start)

            object.style.width = '';
            object.style.height = '';
            object.style.top = '';
            object.style.left = '';
            object.removeAttribute('width');
            object.removeAttribute('height');

            object.style.display = '';  // need for correct rendering in firefox (end)

            imageRatio = (object.width || object.videoWidth) / (object.height || object.videoHeight);

            if (imageRatio <= viewPortRatio) {
                resultWidth = viewPortWidth;
                resultHeight =  viewPortWidth / imageRatio;

                hiddenTop = (viewPortHeight - resultHeight) / 2;
            } else {
                resultWidth = viewPortHeight * imageRatio;
                resultHeight = viewPortHeight;

                hiddenLeft = (viewPortWidth - resultWidth) / 2;
            }

            object.style.display = 'none'; // need for correct rendering in firefox (start)

            object.width = resultWidth;
            object.height = resultHeight;
            object.style.width = resultWidth + 'px';
            object.style.height = resultHeight + 'px';
            object.style.top = hiddenTop + 'px';
            object.style.left = hiddenLeft + 'px';

            object.style.display = '';  // need for correct rendering in firefox (end)
        },

        contain: function (object, viewPortWidth, viewPortHeight) {
            "use strict";

            var viewPortRatio = viewPortWidth / viewPortHeight,
                imageRatio = object.width / object.height,
                resultWidth,
                resultHeight,
                hiddenTop = 0,
                hiddenLeft = 0;

            if (imageRatio <= viewPortRatio) {
                resultWidth = viewPortHeight * imageRatio;
                resultHeight =  viewPortHeight;

                hiddenLeft = (viewPortWidth - resultWidth) / 2;
            } else {
                resultWidth = viewPortWidth;
                resultHeight = viewPortWidth / imageRatio;

                hiddenTop = (viewPortHeight - resultHeight) / 2;
            }

            object.width = resultWidth;
            object.height = resultHeight;
            object.style.width = resultWidth + 'px';
            object.style.height = resultHeight + 'px';
            object.style.top = hiddenTop + 'px';
            object.style.left = hiddenLeft + 'px';
        },

        applyObjectFit: function (list) {
            var count = list.length,
                i,
                cover = DALGAKIRAN.global.cover,
                contain = DALGAKIRAN.global.contain,
                tempParent;

            if (window.CSS && CSS.supports('object-fit', 'cover')) {
                return;
            }

            for (i = 0; i < count; i++) {
                tempParent = list[i].parentNode;

                if (list[i].getAttribute('data-object-fit') === 'cover') {
                    cover(list[i], tempParent.clientWidth, tempParent.clientHeight);
                } else {
                    contain(list[i], tempParent.clientWidth, tempParent.clientHeight);
                }
            }
        },

        addEvents: function (list, event, handler) {
            var count = list.length,
                i;

            for (i = 0; i < count; i++) {
                list[i].addEventListener(event, handler, false);
            }
        },

        dataClickHandler: function (event) {
            var jsonAttr = this.getAttribute('data-click'),
                json,
                item,
                object;
            try {
                json = JSON.parse(jsonAttr);
            } catch (e) {
                console.log(e, jsonAttr);
            }

            if (!json) {
                return;
            }

            for (item in json) {

                if (json.hasOwnProperty(item)) {

                    if (item !== 'function') {

                        object = document.querySelector(json[item]);

                        if (object) {
                            object.classList.toggle(item);
                        }
                    } else {

                        if (typeof DALGAKIRAN.global[json[item]] === 'function') {
                            DALGAKIRAN.global[json[item]].call(this, event);
                        }

                    }
                }

            }
        },

        showCallbackPopup: function () {
            var popup = module.popup.show({
                url: this.getAttribute('data-url'),
                transitionElement: '.popup__window',
                beforeShow: function () {
                    document.body.classList.add('popup-scroll-fix');
                },
                afterClose: function () {
                    document.body.classList.remove('popup-scroll-fix');
                },
                handlers: {
                    popupClose: function (event) {
                        event.preventDefault();
                        document.body.classList.remove('popup-callback-visible');
                        this.hide();
                    },
                    popupWindowClick: function (event) {
                        event.stopPropagation();
                    }
                }
            }).then(function (param) {
                param.dom.querySelector('input').focus();
            });
        },

        showSelectionPopup: function () {
            module.popup.show({
                url: this.getAttribute('data-url'),
                transitionElement: '.popup__window',
                beforeShow: function (popup) {
                    var selects = popup.querySelectorAll('select');

                    module.select.add({
                            element: selects
                        });

                    module.selection.init({
                        object: popup
                    });

                    document.body.classList.add('popup-scroll-fix');
                },
                afterClose: function () {
                    document.body.classList.remove('popup-scroll-fix');
                },
                handlers: {
                    popupClose: function (event) {
                        event.preventDefault();
                        document.body.classList.remove('popup-callback-visible');
                        this.hide().then(function () {
                            module.selection.destroy();
                        });

                    },
                    popupWindowClick: function (event) {
                        event.stopPropagation();
                    }
                }
            });
        },

        getScrollBarWidth: function () {
            var scrollDiv = document.createElement("div"),
                scrollbarWidth,
                style;

            scrollDiv.className = "scrollbar-measure";
            document.body.appendChild(scrollDiv);

            scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);

            style = document.createElement('style');
            style.setAttribute('type', 'text/css');
            style.textContent = '.popup-scroll-fix {margin-right: ' + scrollbarWidth + 'px;overflow: hidden;}';
            document.head.appendChild(style);

            return scrollbarWidth;
        },

        callbackResponse: function (data) {
            data.text().then(function (answer) {
                var answerBlock = document.createElement('div'),
                    popupBlock = document.getElementById('popup-callback-form');

                answerBlock.className = 'popup__answer-wrap';
                answerBlock.innerHTML = answer;

                popupBlock.parentNode.parentNode.appendChild(answerBlock);

                popupBlock.parentNode.classList.add('show-message');
            });
        },

        orderResponse: function (data) {
            data.text().then(function (answer) {
                var answerBlock = document.createElement('div'),
                    popupBlock = document.getElementById('popup-order-form');

                answerBlock.className = 'popup__answer-wrap';
                answerBlock.innerHTML = answer;

                popupBlock.parentNode.parentNode.appendChild(answerBlock);

                popupBlock.parentNode.classList.add('show-message');
            });
        },

        subscribeResponse: function (data) {
            data.text().then(function (answer) {
                var answerBlock = document.createElement('div'),
                    popupBlock = document.getElementById('subscribe-form');

                answerBlock.className = 'popup__answer-wrap';
                answerBlock.innerHTML = answer;

                popupBlock.parentNode.appendChild(answerBlock);

                popupBlock.parentNode.parentNode.classList.add('show-message');
            });
        },

        changeEvent: function (event) {
            var target = event.target,
                name,
                otherItems,
                i,
                count;


            if (target.nodeType === 'input') {
                return;
            }

            if (!target.checked) {
                return;
            }

            if (target.getAttribute('type') === 'checkbox' && target.hasAttribute('data-radio')) {
                name = target.getAttribute('name');
                otherItems = document.querySelectorAll('input[name="' + name + '"]');
                count = otherItems.length;

                for (i = 0; i < count; i++) {
                    if (otherItems[i] !== target) {
                        otherItems[i].checked = false;
                    }
                }
            }
        }
    },

    getControls: function () {
        var ctrl = DALGAKIRAN.controls;

        ctrl.dataClickList = document.querySelectorAll('[data-click]');
        ctrl.dataUrl = document.querySelectorAll('[data-url]');
    },

    setEventList: function () {
        var ctrl = DALGAKIRAN.controls,
            global = DALGAKIRAN.global;

        window.addEventListener('resize', function () {
        }, false);
        window.addEventListener('submit', global.formSubmit, false);

        global.addEvents(ctrl.dataClickList, 'click', global.dataClickHandler);

        module.listener.add({name: 'popup-callback-form', handler: global.callbackResponse});
        module.listener.add({name: 'popup-order-form', handler: global.orderResponse});
        module.listener.add({name: 'subscribe-form', handler: global.subscribeResponse});

        document.body.addEventListener('change', global.changeEvent, false);
    },

    setConfig: function () {
        var ctrl = DALGAKIRAN.controls;

        DALGAKIRAN.global.getScrollBarWidth();
    },

    init: function () {
        window.addEventListener('DOMContentLoaded', function () {
            DALGAKIRAN.getControls();
            DALGAKIRAN.setEventList();
            DALGAKIRAN.setConfig();
        }, false);
    }
};

DALGAKIRAN.init();